import AuthStorage from "../services/AuthStorage"


export default {
  install(Vue) {

    Vue.prototype.$login = function (redirectTo, params = {}) {
      this.$router.push({path: '/login', params});
      Vue.prototype.$redirectAfterLogin = () => {
        this.$router.push(redirectTo);
      };
    };

    Vue.prototype.$auth = {
      isLoggedIn() {
        return AuthStorage.getRefreshToken();
      }
    };

  }
}